/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfAnnouncementDto } from '../../models/platform-api-result-of-announcement-dto';
import { PlatformDeleteByGuidCommandOfAnnouncementDto } from '../../models/platform-delete-by-guid-command-of-announcement-dto';

export interface DeleteNotificationsAnnouncements$Params {
      body: PlatformDeleteByGuidCommandOfAnnouncementDto
}

export function deleteNotificationsAnnouncements(http: HttpClient, rootUrl: string, params: DeleteNotificationsAnnouncements$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfAnnouncementDto>> {
  const rb = new RequestBuilder(rootUrl, deleteNotificationsAnnouncements.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfAnnouncementDto>;
    })
  );
}

deleteNotificationsAnnouncements.PATH = '/api/notifications/announcements';
